module.exports = __webpack_public_path__ + "static/me-0719ba26fd8939d578bd03070f9ed6a2.png";